import { firstCharToUpper } from './utils/functions';
import { caretIcon, skypeIcon } from './utils/icons';

const SkypeButton = ({ attributes, clientId }) => {
	const { skypeID, type, isWhite, size } = attributes;

	window.addEventListener('click', (event) => {
		if (!event.target.matches(`#sbbSkypeButton-${clientId} .dropdown`) && !event.target.matches(`#sbbSkypeButton-${clientId} .dropdown svg`) && !event.target.matches(`#sbbSkypeButton-${clientId} .dropdown svg path`)) {
			const dropdowns = document.querySelectorAll(`#sbbSkypeButton-${clientId} .dropdown .show`);
			dropdowns.forEach(d => {
				if (d.classList.contains('show')) {
					d.classList.remove('show');
				}
			});
		}
	});

	const Item = ({ type, isIcon = true }) => <a href={`skype:${skypeID}?${type}`}>
		{isIcon && skypeIcon(size, isWhite ? '#fff' : '#00aff0')}
		<span>{firstCharToUpper(type)}</span>
	</a>

	return <div className='sbbSkypeButton'>
		{'dropdown' === type ?
			<span className='dropdown' onClick={() => document.getElementById(`dropdownContent-${clientId}`).classList.toggle('show')}>
				{skypeIcon(size, isWhite ? '#fff' : '#00aff0')}
				{/* <span>Call</span> */}
				{caretIcon(size, isWhite ? '#fff' : '#00aff0')}

				<ul id={`dropdownContent-${clientId}`}>
					<li><Item type='call' isIcon={false} /></li>
					<li><Item type='chat' isIcon={false} /></li>
				</ul>
			</span> :
			<Item type={type} />}
	</div>
}
export default SkypeButton;